export function mergeReservaGrupoConStore(reservaGrupo, reservasStore) {
  const reservaStore = reservasStore.find(reserva => reserva.id === reservaGrupo.id);
  if (!reservaStore) {
    return reservaGrupo;
  }

  return {
    ...reservaStore,
    pagos: reservaGrupo.pagos,
    totalPagado: reservaGrupo.totalPagado,
    precioTotal: reservaGrupo.precioTotal ?? reservaStore.precioTotal,
    estado: reservaGrupo.estado,
    nombreUsuario: reservaGrupo.nombreUsuario ?? reservaStore.nombreUsuario,
  };
}
